/** Labels definition for SPAIN SPANISH */
module.exports = {
    __title__:                    'Chat',
    __need_help__:                'Necesita ayuda?',
    __ongoing_chat__:             'Abrir Chat',
    __name__:                     'Nombre',
    __email__:                    'Email',
    __signup__:                   'Comenzar chat',
    __noagents__:                 'No hay agentes disponibles en este momento. Pruebe de nuevo más tarde.',
    __noworkingtime__:            'Chat is closed at this moment.',
    __invalid_name_size__:        'Name cannot be empty',
    __invalid_name__:             'Name cannot contain strange characters',
    __invalid_email__:            'You must provide a valid email address',
    __AGENT_IS_WRITING__:         'Agent is writing',
    __USER_IS_WRITING__:          'User is writing',
    __USER_ONLINE__:              'online',
    __USER_AWAY__:                'away',
    __START_CHAT_WITH_AGENT__:    'Start chat with agent',
    __PLEASE_ENTER_YOUR_NAME__:   'Please enter your name',
    __WELCOME__:                  require('./welcome.hbs'),
    __LOOKING_FOR_AN_AGENT__:     'We are looking for an agent, please wait...',
    __USER_JOINED_CONVERSATION__: require('./user_joined_conversation.hbs'),
    __BTN_SEND__:                 'Send',
    __ERR_EMPTY_MESSAGE__:        'No empty messages',
    __CLOSE_CONFIRM__:            'Do you really want to close and leave chat?',
    __CHAT_FINISHED__:            'Chat finished',
    __USER_LEFT__:                require('./user_left.hbs'),
    __USER_INVITED__:             require('./user_invited.hbs'),
    __USER_REJECTED__:            require('./user_rejected.hbs'),
    __NO_AGENTS__:                'There are no agents available at this moment',
    __BTN_DOWNLOAD__:             'Download conversation',
    __CONVERTED_TO_TICKET__:      require('./converted_to_ticket.hbs'),
    __YES__:                      'yes',
    __NO__:                       'no',
    __CONNECTING__:                 'Conectando...',
    __CHAT_CONTINUE_TO_CUSTOMER_LINK__: '',
    __BTN_CANCEL__:                 'Cancelar',
    __ERR_MESSAGE_TOO_LONG__:       require('./err_message_too_long.hbs'),
    __CHAT_START__:                 'User ',
    __CHAT_USER_DISCONNECT__:       'El usuario se ha desconectado, chat finalizado',
    __UPLOADING__:                  'Subiendo...',
    __CHAT_INTERVENED_BY_AGENT__:   'Este chat ha sido intervenido',
    __CHAT_INTERVENED_BY_ME__:      'Has intervenido este chat',
    __INVITATION_EXPIRING__:        require('./invitation_expiring.hbs'),
};



// WEBPACK FOOTER //
// ./i18n/es_ES/labels.js